import { Component } from '@angular/core';

@Component({
  selector: 'app-file-icon',
  standalone: true,
  host: { class: 'ui-icon' },
  templateUrl: './file-icon.component.html',
  styleUrl: '../icon-base.scss'
})
export class FileIconComponent {}
